import clsx from 'clsx';

/**
 * className
 * A utility for adding classNames dynamically. See docs for examples.
 * @link https://www.npmjs.com/package/clsx
 */
export const cn = clsx;
